import { DataPartHelper } from './data-part-helper';

interface AgentErrorPartBlockProps {
  data: unknown;
}

/** An error the agent recorded mid-turn: a failed builder step, or a research angle that threw. */
export function AgentErrorPartBlock({ data }: AgentErrorPartBlockProps) {
  return (
    <p className="text-chat-destructive txt-small-regular">
      {DataPartHelper.getErrorMessage(data)}
    </p>
  );
}
